module.exports = __webpack_public_path__ + "static/gui-91f7556666460b213df3888a783cb31c.jpg";